export default __webpack_public_path__ + "static/media/kanishk.7da0e547.webp";